import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['options', 'toggler']

  initialize() {
    this.expanded = false
  }

  connect() {
    if (this.optionsTargets.length > this.itemsThreshold) this._createToggler()
    if (!this.expanded) this.hideable.forEach((element) => element.classList.add('hide'))
  }

  disconnect() {
    this.expanded = false
    if (this.hasTogglerTarget) this.togglerTarget.remove()
  }

  toggle() {
    this.expanded = !this.expanded
    this.hideable.forEach((element) => element.classList.toggle('hide'))
    this.togglerTarget.innerText = this.expanded ? this.lessLabel : this.moreLabel
  }

  _createToggler() {
    const button = document.createElement('button')
    button.type = 'button'
    button.classList.add('more-results')
    button.dataset.expandFiltersTarget = `toggler`
    button.dataset.action = `${this.scope.identifier}#toggle`
    button.innerText = this.moreLabel
    this.element.appendChild(button)
  }

  get lessLabel() {
    return this.data.get('less') || 'Menos'
  }

  get moreLabel() {
    return this.data.get('more') || 'Mais'
  }

  get itemsThreshold() {
    return this.data.get('threshold') || 5
  }

  get hideable() {
    return this.optionsTargets.slice(5)
  }
}